import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import Cookies from 'js-cookie';

const ChartThree = ({googlePropertyId}) => {  const [chartData, setChartData] = useState({
    series: [0, 0, 0, 0], // Initialize with default values
    labels: ['Desktop', 'Tablet', 'Mobile', 'Unknown'], // Labels for the chart
    percentages: [0, 0, 0, 0] // Add percentages array
});

  const [timeRange, setTimeRange] = useState('monthly'); // Track selected time range

  // Fetch device data based on selected time range (monthly or yearly)
  const fetchDeviceData = async (range) => {
    const dateRanges = {
        monthly: 30,
        yearly: 365,
    };

    try {
      const adminToken = Cookies.get('adminKey');
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URI}analytics/devices?daysAgo=${dateRanges[range]}&propertyId=${googlePropertyId}`, {
        method: 'GET',
        headers: {
          "Admin-Token": adminToken
        }
      });

      if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      // Process the data to match the chart's structure
      const deviceCounts = {
          desktop: 0,
          tablet: 0,
          mobile: 0,
          unknown: 0,
      };

      data.rows.forEach((row) => {
          const deviceCategory = row[0];
          const activeUsers = parseInt(row[1], 10); // Parse as integer

          deviceCounts[deviceCategory] = activeUsers;
      });      // Create series data for the chart
      const seriesData = [
          deviceCounts.desktop,
          deviceCounts.tablet,
          deviceCounts.mobile,
          deviceCounts.unknown,
      ];

      // Calculate total for percentage calculation
      const total = seriesData.reduce((sum, value) => sum + value, 0);
      
      // Calculate percentages
      const percentages = seriesData.map(value => 
          total > 0 ? Math.round((value / total) * 100) : 0
      );

      setChartData({ 
          series: seriesData, 
          labels: ['Desktop', 'Tablet', 'Mobile', 'Unknown'],
          percentages: percentages 
      });
    } catch (error) {
        console.error('Error fetching device data:', error);
        // Handle error appropriately (e.g., display an error message)
    }
};


  // Handle time range selection change
  const handleTimeRangeChange = (event) => {
    const selectedRange = event.target.value;
    setTimeRange(selectedRange);
    fetchDeviceData(selectedRange); // Fetch data for the selected range
  };

  useEffect(() => {
    fetchDeviceData(timeRange); // Initial fetch based on the default range (monthly)
  }, [timeRange]);

  const options = {
    chart: {
      fontFamily: 'Satoshi, sans-serif',
      type: 'donut',
    },
    colors: ['#3C50E0', '#6577F3', '#8FD0EF', '#0FADCF'],
    labels: chartData.labels,
    series: chartData.series,
    legend: {
      show: false,
      position: 'bottom',
    },
  
    plotOptions: {
      pie: {
        donut: {
          size: '65%',
          background: 'transparent',
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
    responsive: [
      {
        breakpoint: 2600,
        options: {
          chart: {
            width: 380,
          },
        },
      },
      {
        breakpoint: 640,
        options: {
          chart: {
            width: 200,
          },
        },
      },
    ],
  };

  return (
    <div className="sm:px-7.5 col-span-12 rounded-2xl border border-stroke bg-white px-5 pb-5 pt-7.5 shadow-default dark:border-strokedark dark:bg-boxdark xl:col-span-5">
      <div className="mb-3 justify-between gap-4 sm:flex">
        <div>
          <h5 className="text-xl font-semibold text-black dark:text-white">
            Devices
          </h5>
        </div>
        <div>
          <div className="relative z-20 inline-block">
            <select
              value={timeRange}
              onChange={handleTimeRangeChange}
              className="relative z-20 inline-flex appearance-none bg-transparent py-1 pl-3 pr-8 text-sm font-medium outline-none"
            >
              <option value="monthly" className="dark:bg-boxdark">
                Mensile
              </option>
              <option value="yearly" className="dark:bg-boxdark">
                Annuo
              </option>
            </select>
            <span className="absolute right-3 top-1/2 z-10 -translate-y-1/2">
              <svg
                width="10"
                height="6"
                viewBox="0 0 10 6"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.47072 1.08816C0.47072 1.02932 0.500141 0.955772 0.54427 0.911642C0.647241 0.808672 0.809051 0.808672 0.912022 0.896932L4.85431 4.60386C4.92785 4.67741 5.06025 4.67741 5.14851 4.60386L9.09079 0.896932C9.19376 0.793962 9.35557 0.808672 9.45854 0.911642C9.56151 1.01461 9.5468 1.17642 9.44383 1.27939L5.50155 4.98632C5.22206 5.23639 4.78076 5.23639 4.51598 4.98632L0.558981 1.27939C0.50014 1.22055 0.47072 1.16171 0.47072 1.08816Z"
                  fill="#637381"
                />
              </svg>
            </span>
          </div>
        </div>
      </div>

      <div id="chartThree" className="mx-auto flex justify-center mb-5">
        <ReactApexChart options={options} series={chartData.series} type="donut" />
      </div>

      <div className="-mx-8 flex flex-wrap items-center justify-center gap-y-3">
        {chartData.series.map((value, index) => ( // Map over the series data
          <div className="sm:w-1/2 w-full px-8" key={index}> {/* Add key prop */}
            <div className="flex w-full items-center">
              <span
                className={`mr-2 block h-3 w-full max-w-3 rounded-full ${
                  index === 0
                    ? 'bg-primary'
                    : index === 1
                    ? 'bg-[#6577F3]'
                    : index === 2
                    ? 'bg-[#8FD0EF]'
                    : 'bg-[#0FADCF]'
                }`}
              ></span>              <p className="flex w-full justify-between text-sm font-medium text-black dark:text-white">
                <span>{chartData.labels[index]}</span>
                <span>{chartData.percentages ? chartData.percentages[index] : 0}%</span>
              </p>
            </div>
          </div>
        ))}
      </div>

    </div>
  );
};

export default ChartThree;
